import React, { Fragment } from "react";

export interface ShowHideProps {
  condition: boolean;
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  children: React.ReactNode;
}

const Show: React.FC<ShowHideProps> = ({ condition, as: Component = Fragment, children }) => {
  return condition ? <Component>{children}</Component> : null;
};

const Hide: React.FC<ShowHideProps> = ({ condition, as: Component = Fragment, children }) => {
  return !condition ? <Component>{children}</Component> : null;
};

export { Show, Hide };
